import { Briefcase, Building2, CalendarDays, Car, Map, Package, Plane, Repeat, Route, Sparkles, Sun, type LucideIcon } from 'lucide-react';

const ICONS: Record<string, LucideIcon> = {
  car: Car,
  plane: Plane,
  route: Route,
  map: Map,
  briefcase: Briefcase,
  calendar: CalendarDays,
  repeat: Repeat,
  sun: Sun,
  building: Building2,
  sparkles: Sparkles,
  package: Package,
};

export function ServiceIcon({ name, className = 'size-6' }: { name: string | null | undefined; className?: string }) {
  const Icon = (name && ICONS[name]) || Car;
  return <Icon className={className} aria-hidden strokeWidth={1.8} />;
}
